import { MutableRefObject, useRef } from 'react';
import { MapRef, useMap } from 'react-map-gl';
import { DEDUPLICATION_MAP_ID } from '../consts';


export type RefToMap = MutableRefObject<MapRef | undefined>;
export const useDeduplicationMap = (): RefToMap => {
    const map = useMap()[DEDUPLICATION_MAP_ID];
    const ref = useRef<MapRef>();
    ref.current = map;
    return ref;
};